/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_Dim_CitabilityInputs */

const en_directory_detail_signals_geo_dim_citability = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_CitabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content & citability`)
};

const zh_directory_detail_signals_geo_dim_citability = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_CitabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容与可引用性`)
};

/**
* | output |
* | --- |
* | "Content & citability" |
*
* @param {Directory_Detail_Signals_Geo_Dim_CitabilityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_dim_citability = /** @type {((inputs?: Directory_Detail_Signals_Geo_Dim_CitabilityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_Dim_CitabilityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_dim_citability(inputs)
	return zh_directory_detail_signals_geo_dim_citability(inputs)
});
export { directory_detail_signals_geo_dim_citability as "directory.detail.signals.geo_dim.citability" }